import { createSlice } from "@reduxjs/toolkit";
import {
    getAllSalaryUsers, getAllSalarySlipsByEmployeeID, getPreviousMonthPayroll, bulkUploadSalarySlips, downloadSalaryFormat
} from './thunk';

export const initialState = {
    employeeSalaryList: [],
    previousMonthPayroll: null,
    errors: {}
};

const UsersSlice = createSlice({
    name: 'SalaryPayroll',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllSalaryUsers.fulfilled, (state: any, action: any) => {
            state.employeeSalaryList = action.payload;
        });
        builder.addCase(getAllSalaryUsers.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getAllSalarySlipsByEmployeeID.fulfilled, (state: any, action: any) => {
            state.employeeSalaryList = action.payload;
        });
        builder.addCase(getAllSalarySlipsByEmployeeID.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getPreviousMonthPayroll.fulfilled, (state: any, action: any) => {
            state.previousMonthPayroll = action.payload;
        });
        builder.addCase(getPreviousMonthPayroll.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(bulkUploadSalarySlips.fulfilled, (state: any, action: any) => {
            // Handle bulk upload success if needed
        });
        builder.addCase(bulkUploadSalarySlips.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(downloadSalaryFormat.fulfilled, (state: any, action: any) => {
            // Handle download success if needed
        });
        builder.addCase(downloadSalaryFormat.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default UsersSlice.reducer;